<!-- Switch Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <div class="flex flex-grow-1 flex-row column-gap-2 align-items-center p-3">
      <div class="flex flex-1">
        <p-slider ariaLabelledBy="{{ name }}_label"
          class="w-full"
          styleClass="{{ inputClass }}"
          formControlName="{{ name }}"
          [disableControl]="disabled"
          [max]="max"
          [min]="min"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
          (onSlideEnd)="valueChange.emit($event)">
        </p-slider>
      </div>
      <div class="flex justify-content-end w-4rem">
        <span class="white-space-wrap">{{ (control.getRawValue() | number: '1.0-0') + (isPercentage ? ' %' : '') }}</span>
      </div>
    </div>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error w-max">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}
